import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

import pega from "../../assets/images/pega-Photoroom.png";
import camunda from "../../assets/images/camunda-Photoroom.png";
import servicenow from "../../assets/images/servicenow-Photoroom.png";
import antwork from "../../assets/images/antworks-Photoroom.png";
import ibm from "../../assets/images/ibm.png";

const PARTNERS = [
  {
    name: "Pega Systems",
    logo: pega,
    tagline: "Enterprise Automation & Decisioning",
  },
  {
    name: "Camunda",
    logo: camunda,
    tagline: "Process Orchestration & Workflow",
  },
  {
    name: "ServiceNow",
    logo: servicenow,
    tagline: "Digital Workflows & Cloud Ops",
  },
  {
    name: "AntWorks",
    logo: antwork,
    tagline: "Intelligent Document Processing",
  },
  {
    name: "IBM",
    logo: ibm,
    tagline: "AI & Hybrid Cloud Scale",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function ExpertiseGrid() {
  return (
    <section className="relative w-full lg:py-24 md:py-16 py-10 bg-[#f7f7f5] text-slate-900 overflow-hidden">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[450px] w-[850px] rounded-full bg-slate-200/50 blur-[130px]" />
      <div className="mx-auto 3xl:w-4/5 lg:w-11/12  px-6 md:px-12 relative z-10">
        <div className="flex flex-col items-center text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full backdrop-blur-md shadow-xs mb-3"
          >
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-600">
              Technology Ecosystem
            </span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#000036]"
          >
            Our{" "}
            <span className="italic font-serif font-normal text-[#5dc9f0]">
              Expertise
            </span>{" "}
          </motion.h2>
        </div>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
        >
          <motion.div
            variants={itemVariants}
            className="group p-8 lg:p-12 flex flex-col justify-between items-center text-center md:border-r border-b border-slate-300 hover:bg-white/50 transition-colors duration-300"
          >
            <div className="flex-1 flex items-center justify-center w-full py-6">
              <img
                src={PARTNERS[0].logo}
                alt={`${PARTNERS[0].name} logo`}
                className="max-h-20 sm:max-h-24 w-auto max-w-[80%] object-contain  transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
              />
            </div>
            <p className="text-xs sm:text-base font-semibold text-slate-500 group-hover:text-slate-900 transition-colors">
              {PARTNERS[0].tagline}
            </p>
          </motion.div>
          <motion.div
            variants={itemVariants}
            className="group p-8 xl:p-12 flex flex-col justify-between items-center text-center md:border-r border-b border-slate-300 hover:bg-white/50 transition-colors duration-300"
          >
            <div className="flex-1 flex items-center justify-center w-full py-6">
              <img
                src={PARTNERS[1].logo}
                alt={`${PARTNERS[1].name} logo`}
                className="max-h-20 sm:max-h-24 w-auto max-w-[80%] object-contain transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
              />
            </div>
            <p className="text-xs sm:text-base font-semibold text-slate-500 group-hover:text-slate-900 transition-colors">
              {PARTNERS[1].tagline}
            </p>
          </motion.div>
          <motion.div
            variants={itemVariants}
            className="group p-8 xl:p-12 flex flex-col justify-between items-center text-center border-b md:border-r lg:border-r-0 border-slate-300 hover:bg-white/50 transition-colors duration-300"
          >
            <div className="flex-1 flex items-center justify-center w-full py-6">
              <img
                src={PARTNERS[2].logo}
                alt={`${PARTNERS[2].name} logo`}
                className="max-h-20 sm:max-h-24 w-auto max-w-[80%] object-contain  transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
              />
            </div>
            <p className="text-xs sm:text-base font-semibold text-slate-500 group-hover:text-slate-900 transition-colors">
              {PARTNERS[2].tagline}
            </p>
          </motion.div>
          <motion.div
            variants={itemVariants}
            className="group p-8 xl:p-12 flex flex-col justify-between items-center text-center md:border-r border-b lg:border-b-0 border-slate-300 hover:bg-white/50 transition-colors duration-300"
          >
            <div className="flex-1 flex items-center justify-center w-full py-6">
              <img
                src={PARTNERS[3].logo}
                alt={`${PARTNERS[3].name} logo`}
                className="max-h-20 sm:max-h-24 w-auto max-w-[80%] object-contain transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
              />
            </div>
            <p className="text-xs sm:text-base font-semibold text-slate-500 group-hover:text-slate-900 transition-colors">
              {PARTNERS[3].tagline}
            </p>
          </motion.div>
          <motion.div
            variants={itemVariants}
            className="group p-8 xl:p-12 flex flex-col justify-between items-center text-center md:border-r border-b md:border-b-0 border-slate-300 hover:bg-white/50 transition-colors duration-300"
          >
            <div className="flex-1 flex items-center justify-center w-full py-6">
              <img
                src={PARTNERS[4].logo}
                alt={`${PARTNERS[4].name} logo`}
                className="max-h-20 sm:max-h-24 w-auto max-w-[80%] object-contain  transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
              />
            </div>
            <p className="text-sm sm:text-base font-semibold text-slate-500 group-hover:text-slate-900 transition-colors">
              {PARTNERS[4].tagline}
            </p>
          </motion.div>
          <motion.div
            variants={itemVariants}
            className="p-8 xl:p-12 flex flex-col justify-between text-left  bg-[#000036]  transition-colors duration-300"
          >
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-white">
                Core Platforms
              </span>
              <h3 className="mt-2 text-xl sm:text-2xl font-bold text-white tracking-tight leading-snug">
                Powering high-impact enterprise workflows.
              </h3>
              <p className="mt-3 text-base text-white leading-relaxed">
                Deploying certified architectures across global automation
                engines.
              </p>
            </div>
            <div className="mt-6 pt-4 border-t border-slate-200/80 flex items-center justify-between">
              <span className="text-xs font-semibold text-white uppercase tracking-wider">
                Certified Stack
              </span>
              <ArrowUpRight size={17} className="text-white" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
